// Svg
import navigation from "../Assets/navigation";

export const navigationRoute = [
  {
    path: "dashboard",
    label: "Dashboard",
    svg: navigation?.dashboard,
  },
  {
    path: "users",
    label: "Users",
    svg: navigation?.users,
  },
  {
    path: "user-type",
    label: "Manage User Level",
    svg: navigation?.manageType,
  },
  {
    path: "organization",
    label: "Manage Organization",
    svg: navigation?.orgTeam,
  },
  {
    path: "manage-ai",
    label: "Manage AI",
    svg: navigation?.sensAI,
    type: "submenu",
    list: [
      {
        path: "ai-usage",
        label: "AI Usage",
        svg: navigation?.sensAI,
      },
      {
        path: "ai-settings",
        label: "AI Settings",
        svg: navigation?.sensAISetting,
      },
      {
        path: "ai-credits",
        label: "AI Credits",
        svg: navigation?.sensAI,
      },
      {
        path: "ab-testing",
        label: "AB Testing",
        svg: navigation?.abtesting,
      },
    ],
  },
  {
    path: "manage-subscription",
    label: "Manage Subscription",
    svg: navigation?.subscription,
    type: "submenu",
    list: [
      {
        path: "subscription",
        label: "Subscription",
        svg: navigation?.subscription,
      },
      {
        path: "transaction",
        label: "Transaction History",
        svg: navigation?.transaction,
      },
      {
        path: "manage-plan",
        label: "Manage Plan",
        svg: navigation?.manageType,
      },
    ],
  },
  {
    path: "import-experience-history",
    label: "Import Experience History",
    svg: navigation?.experience,
  },
  {
    path: "notification-template",
    label: "Notification Template",
    svg: navigation?.notification,
  },
  {
    path: "email-template",
    label: "Email Templates",
    svg: navigation?.email,
  },
  // {
  //   path: "document-template",
  //   label: "Document Templates",
  //   svg: navigation?.document,
  // },
  {
    path: "beta-program",
    label: "Beta Program Content",
    svg: navigation?.beta,
  },
  {
    path: "newsletter",
    label: "Newsletter",
    svg: navigation?.newsletter,
  },
  // {
  //   path: "cosmos/theme",
  //   label: "Cosmos Theme",
  //   svg: navigation?.cosmosTheme,
  // },
  // {
  //   path: "cosmos/pages",
  //   label: "Cosmos Pages",
  //   svg: navigation?.cosmosPage,
  // },
  // {
  //   path: "cosmos/widgets",
  //   label: "Cosmos Widgets",
  //   svg: navigation?.cosmosWidget,
  // },
  {
    path: "faq",
    label: "FAQ",
    svg: navigation?.faq,
  },
  {
    path: "support",
    label: "Support",
    svg: navigation?.support,
  },
  {
    path: "support-for-user",
    label: "User Support",
    svg: navigation?.supportTeam,
  },
  // {
  //   path: "analytics",
  //   label: "Analytics",
  //   svg: navigation?.analytics,
  // },
  // {
  //   path: "content",
  //   label: "Content",
  //   svg: navigation?.content,
  // },
  // {
  //   path: "application",
  //   label: "Applications",
  //   svg: navigation?.application,
  // },
];

// AI
export const aiNameList = [
  {
    name: "Tokens",
    bgColor: "rgba(62, 162, 141, 1)",
    borderColor: "rgba(62, 162, 141, .5)",
  },
  {
    name: "Hours",
    bgColor: "rgba(255, 122, 0, 1)",
    borderColor: "rgba(255, 122, 0, .5)",
  },
  {
    name: "Images",
    bgColor: "rgb(2, 76, 170,1)",
    borderColor: "rgb(2, 76, 170,.5)",
  },
  {
    name: "Credits",
    bgColor: "rgba(76, 175, 80, 1)",
    borderColor: "rgba(76, 175, 80, .5)",
  },
];
